const styles = {
  colors: {
    gray: {
      50: '#F3F3F4',
      100: '#E6E7E9',
      200: '#C9CBCE',
      300: '#ABAFB2',
      400: '#8E9297',
      500: '#70767B',
      600: '#535A60',
      700: '#3B4045',
      800: '#242729',
      900: '#181A1B',
      950: '#0C0D0E',
    },
    orange: {
      500: '#F79727',
    },
    white: '#ffffff',
    black: '#000000',
    red: {
      100: '#ffdddd',
      300: '#ff5d5d',
      500: '#d91a00',
    },
    green: {
      500: '#8CC63E',
    },
    blue: {
      50: '#E7F1F9',
      100: '#CFE2F3',
      200: '#9CC4E3',
      300: '#68A5D2',
      400: '#3486C2',
      500: '#0067B1',
      600: '#005B9D',
      700: '#004F88',
      800: '#004F88',
      900: '#00375F',
      950: '#001C30',
    },
  },
};

export default styles;
